import { useMutation } from 'react-query';
import { get } from 'lodash';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { Types, Mappers, Apis } from '../';

export const useCreate = () => {
  const { i18n } = useTranslation();

  return useMutation<Types.Entity.Refund, string, { id: number }, Types.Entity.Refund>({
    mutationFn: async ({ id }) => {
      const { data } = await Apis.Create({ id });
      const messageTitle = get(data, 'message.title') || '';

      if (!!messageTitle) {
        toast.loading(messageTitle[i18n.language] || messageTitle);
      }

      return Mappers.Refund(get(data, 'data'));
    }
  });
};
